import UserNotification from './UserNotification';

export default UserNotification;
